"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../../fonts/index.js");const t={VDS:{mobile:{fontSize:11,lineHeight:16,fontWeight:"normal",fontFamily:e.Fonts.NeueHaasGroteskText},desktop:{fontSize:11,lineHeight:16,fontWeight:"normal",fontFamily:e.Fonts.NeueHaasGroteskText}},MVP:{mobile:{fontSize:10,lineHeight:12,fontWeight:"400",fontFamily:e.Fonts.NeueHaasGroteskText},desktop:{fontSize:10,lineHeight:12,fontWeight:"400",fontFamily:e.Fonts.NeueHaasGroteskText}},getStyles:function(e,o){return t[e][o]}};exports.default=t;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/typography/cjs/components/Micro/config.js
// module id = 1376
// module chunks = 0